<template>
<div  style="padding:20px">
    <div class="stretch-vertical">
        <div class="stretch-horizontal">
            <div class="stretch-vertical" style="overflow:auto;border:1px solid #eee;flex:0 0 400px">
                <div class="stretch-vertical" style="overflow:auto">
                    <tab-tree-view :item="tabTree"
                        :selected="selectedTab" 
                        :allowEdit="true" 
                        :all="flattedTabs" 
                        @toggle-item="toggleItem" 
                        @modify-item="modifyItem">
                    </tab-tree-view>
                </div>
                <!-- <button type="button" data-toggle="modal" data-target="#confirmLiveModal" class="btn btn-success btn-sm m-2">Go live</button>
                 <div class="modal" id="confirmLiveModal" >
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Go live</h5>
                        </div>
                        <div class="modal-body">
                            <p>The tabs and contents from this staging site will be pushed to the production website. You cannot undo this process.</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancel</button>
                            <button v-show="!isPushingToLive" type="button" class="btn btn-success btn-sm" @click="goLive">Go live</button>
                            <i v-show="isPushingToLive" class="fa fa-refresh fa-spin fa-fw"></i>
                        </div>
                    </div>
                </div>
                </div> -->
            </div>     
            <div class="stretch-vertical" style="margin-left: 10px;">
                 <div class="message-containerd">
                    <div v-if="errorMessage !== ''" class="alert alert-danger" role="alert">
                    {{errorMessage}}
                    <button type="button" class="close" aria-label="Close" @click="errorMessage = ''">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>

                    <div v-if="successMessage !== ''" class="alert alert-success" role="alert" >
                    {{successMessage}}
                    <button type="button" class="close" aria-label="Close" @click="successMessage = ''">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                </div>
                <div class="stretch-vertical" v-show="selectedTab.Id !== null">
                <textarea id="md"></textarea>
                <div class="row buttons-and-dropdown-area">
                    <div class="col file-dropdown-container">
                        <div class="dropdown-area" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                            <input class="dropdown-area-input" type="file" id="assetsFieldHandle" @change="selectFile($event.target.files)" 
                                ref="file" accept="image/*,video/*,.pdf" />
                            <label class="dropdown-area-label" for="assetsFieldHandle">
                                <p>Drop your file here to convert to markdown <br>or <span style="text-decoration: underline">click here</span> to browse</p>
                            </label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="input-group input-group-sm mb-5">
                            <input ref="formAssemblyLink" class="form-control" placeholder="Paste FormAssembly link here (e.g. https://tfaforms.com/1234567)" @change="faLinkToMarkdown()"/>
                            <div class="input-group-append">
                                <button @click="faLinkToMarkdown()" type="button" class="btn btn-outline-info">Generate form link</button>
                            </div>
                        </div>
                        <div class="input-group input-group-sm">
                            <input ref="fileMarkdownText" class="form-control" v-model="generatedMarkdownText" />
                            <div class="input-group-append">
                                <button type="button" class="btn btn-outline-info" @click="copyText()">Copy text</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-auto">
                    <div class="btn-group btn-group-sm">
                        <button class="btn btn-dark" @click="submit()">Save</button>
                        <button class="btn btn-secondary" @click="revert()">Revert</button>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style>
</style>

<script>
/* eslint-disable */
import axios from 'axios'
import Loading from 'vue-loading-overlay';
import { GuidService } from '../../services/guid';
import 'vue-loading-overlay/dist/vue-loading.css';
import TabTreeView from '../../components/TabTreeView.vue';

export default {
    data() {
        return {
            errorMessage: '',
            successMessage: '',
            pageList: null,
            pageContent: '',
            pagePath: '',
            mdeInstance: null,
            activeIndex: null,
            isLoading: false,
            droppedFile: null,
            droppedFileGuid: null,
            formAssemblyLink: null,

            tabTree: {
                Name: 'HLS Website Tabs',
                Id: null,
                Children: []
            },
            flattedTabs:[],
            selectedTab: {
                Id: null,
                Name: null,
                Display: null
            },
            isNotLeafTab: true,

            isPushingToLive: false
        }
    },
    components: {
      Loading,
      TabTreeView
    },
    created: function() {
        this.fetchTabs();
    },
    computed: {
        generatedMarkdownText: function() {
            const videoRegex = /video/;
            const imageRegex = /image/;
            let generatedText = '';
            if (this.droppedFile) {
                if (videoRegex.test(this.droppedFile.type)) {
                    generatedText = `<video controls="true" allowfullscreen="true"><source src="${this.rootUrl}/api/files/${this.droppedFileGuid}" type =${this.droppedFile.type}></video>`;
                }
                else if (imageRegex.test(this.droppedFile.type)) {
                    generatedText = `![](${this.rootUrl}/api/files/${this.droppedFileGuid})`; 
                }
                else {
                    generatedText = `[](${this.rootUrl}/api/files/${this.droppedFileGuid})`; 
                }
                
                this.droppedFile = null;
                this.droppedFileGuid = null;
            }
            else if (this.formAssemblyLink) {
                generatedText = `<iframe width="100%" height="100%" frameborder=0 scrolling="auto" src="${this.formAssemblyLink}"></iframe>`;
                this.formAssemblyLink = null;
            }
            return generatedText;
        },
        rootUrl: function() {
            if (window.location.origin === 'http://localhost:3000') {
                return 'http://localhost:62737';
            } else {
                return '.';
            }
        }
    },
    destroyed: function() {
         window.onbeforeunload = null;
    },
    mounted: function() {
        this.mdeInstance = new SimpleMDE({ 
            element: $("#md")[0], 
            hideIcons: ["fullscreen", "side-by-side"], 
            spellChecker: false,	
            previewRender: function(plainText) {
		        return marked(plainText); // Returns HTML from a custom parser
	        }, 
        });

        this.activeIndex = 0;

        window.onbeforeunload = function() {
            return "Are you sure you want to navigate away?";
        }
    },
    methods: {
        revert: function(e) {
            this.successMessage = '';
            this.errorMessage = '';
            const vm = this;
             axios.get('api/pagecontent/' + this.selectedTab.Id)
             .then(response => {
     
                vm.pageContent = response.data.Content;
                vm.mdeInstance.value(vm.pageContent);

                vm.successMessage = 'Content reverted';
            })
            .catch(function (error) {
                vm.errorMessage = 'An error occurred getting the page content';
            });
        },
        changePage: function(tab) {
            const vm = this;
            vm.errorMessage = '';
            vm.successMessage = '';
            axios.get('api/pagecontent/' + tab.Id).then(response => {
                if (!response.data) {
                    vm.pageContent = '';
                } else {
                    vm.pageContent = response.data.Content;
                }

                vm.mdeInstance.value(vm.pageContent);

                // refresh the mde instance because of bugs...
                setTimeout(function() { 
                    vm.mdeInstance.codemirror.refresh(); 
                }, 0);
            })
            .catch(() => {
                vm.errorMessage = 'An error occurred getting the page content';
            });
        },
        submit: function (e) {
            const vm = this;
            this.isLoading = true;
            this.serverErrors = [];
            this.successMessage = '';
            axios.post('/api/pagecontent/' + vm.selectedTab.Id, {
                PageContent: vm.mdeInstance.value(),
            }).then(function (response) {
                if (response.status === 200) {
                  // set some message of success
                  vm.successMessage = "Changes Saved Successfully";
                } else {
                    vm.errorMessage = 'Error saving page content';
                }
                vm.isLoading = false;
            })
            .catch(function (error) {
                vm.isLoading = false;
                vm.errorMessage = 'An error occurred saving the page content';
            });
        },
        onChange: function() {
            this.droppedFile = this.$refs.file[0];
            this.droppedFileGuid = GuidService.new();

            const formData = new FormData();
            formData.append('file', this.droppedFile);

            axios.put(`/api/files/add/${this.droppedFileGuid}`, 
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
        },
        dragover: function(event) {
            event.preventDefault();
            if (event.currentTarget.style['background-color'] != "rgba(110, 231, 183, 1)") {
                event.currentTarget.style['background-color'] = "rgba(110, 231, 183, 1)";
            }
        },
        dragleave: function(event) {
            event.currentTarget.style['background-color'] = "rgba(243, 244, 246, 1)";
        },
        drop: function(event) {
            event.preventDefault();
            this.$refs.file = event.dataTransfer.files;
            this.onChange();
            event.currentTarget.style['background-color'] = "rgba(243, 244, 246, 1)";
        },
        selectFile: function(fileList) {
            this.$refs.file = fileList;
            this.onChange();
        },
        copyText: function(e) {
            const mdText = this.$refs.fileMarkdownText;
            mdText.select();
            document.execCommand("copy");
        },
        faLinkToMarkdown: function(e) {
            const faLinkRegex = /https:\/\/tfaforms.com\//;
            if (!faLinkRegex.test(this.$refs.formAssemblyLink.value)) {
                return;
            }
            this.formAssemblyLink = this.$refs.formAssemblyLink.value;
        },
        goLive: function() {
            alert('Function disabled');
            return;
            const vm = this;
            vm.isPushingToLive= true;
            axios.post('/api/pagecontent/updateall').then(() => {
                vm.isPushingToLive = false;
                $('#confirmLiveModal').modal('hide');
                 vm.successMessage = "Changes Saved Successfully";
            }).catch(() => {
                vm.isPushingToLive = false;
                $('#confirmLiveModal').modal('hide');
                vm.errorMessage = 'An error occurred while pushing contents to live';
            });
        },

        toggleItem: function (tab) {
            this.changePage(tab);
            var display = tab.Name;
            //find ancestors
            let current = tab;
            while (current.Parent) {
                var parent = this.flattedTabs.find(f => f.Id === current.Parent);
                display = parent.Name + ' > ' + display;
                current = parent;
            }

            this.selectedTab = {
                Id: tab.Id,
                Name: tab.Name,
                Display: display
            }
        },
        fetchTabs: function() {
            this.isLoading = true;
            axios.get('/api/webtabs/tree').then(res => {
                this.tabTree.Children = res.data;
                //this.toggleItem(this.tabTree);

                this.isLoading = false;
            });

            axios.get('/api/webtabs/all').then(res => {
                this.flattedTabs = res.data;
            })
        },
        modifyItem: function (itemAct) {
            if (itemAct.action === 'edit'){
                if (itemAct.model.Name === itemAct.tab.name) return;
                itemAct.model.Name = itemAct.tab.name;
                itemAct.model.Mode = itemAct.tab.mode;
                
                axios.post(`api/webtabs/update/${itemAct.model.Id}`, itemAct.model).then(() => {
                    this.fetchTabs();
                });
            } else if(itemAct.action === 'insertabove' || itemAct.action === 'insertbelow') {
                
                let curr = this.flattedTabs.find(f => f.Id === itemAct.model.Id);
                let siblings = this.flattedTabs
                    .filter(f => f.Parent === itemAct.model.Parent)
                    .sort((a, b) => a.Ordinal - b.Ordinal);

                let indexOfCurr = siblings.indexOf(curr);
                let currOrdinal = curr.Ordinal;

                let neighbor;
                if (itemAct.action === 'insertabove') {
                    neighbor = indexOfCurr === 0 ? 0 : siblings[indexOfCurr-1].Ordinal;
                } else {
                    neighbor = indexOfCurr === siblings.length - 1 ? siblings.length : siblings[indexOfCurr+1].Ordinal;
                }

                let newOrdinal = (parseFloat(currOrdinal) + parseFloat(neighbor)) / 2.0;

                if (itemAct.tab.id) {
                    let tabToMove = {
                        Id: itemAct.tab.id,
                        Name: itemAct.tab.name,
                        Parent: itemAct.model.Parent,
                        Ordinal: newOrdinal,
                        Mode: itemAct.tab.mode
                    };

                    axios.post(`api/webtabs/update/${itemAct.tab.id}`, tabToMove).then(() => {
                        this.fetchTabs();
                    });
                }
                else {
                    let tabToAdd = {
                        Id: GuidService.new(),
                        Name: itemAct.tab.name,
                        Parent: itemAct.model.Parent,
                        Ordinal: newOrdinal,
                        Mode: itemAct.tab.mode
                    };

                    axios.put('api/webtabs/add', tabToAdd).then(() => {
                        this.fetchTabs();
                    });
                }
            } else if(itemAct.action === 'delete') {
                if (itemAct.model.Children.length !== 0) {
                    this.errorMessage = 'This tab cannot be deleted because it has one or more sub tabs.';
                    return;
                }

                axios.post(`api/webtabs/delete/${itemAct.model.Id}`).then(() => {
                    this.fetchTabs();
                });
            } else if(itemAct.action === 'addchild') {

                if (itemAct.tab.id) {
                    let tabToMove = {
                        Id: itemAct.tab.id,
                        Name: itemAct.tab.name,
                        Parent: itemAct.model.Id,
                        Ordinal: 1,
                        Mode: itemAct.tab.mode
                    };

                    if (tabToMove.Id === tabToMove.Parent) {
                        return;
                    }

                    axios.post(`api/webtabs/update/${itemAct.tab.id}`, tabToMove).then(() => {
                        this.fetchTabs();
                    });
                } else {
                    let newtab = {
                        Id: GuidService.new(),
                        Name: itemAct.tab.name,
                        Parent: itemAct.model.Id,
                        Ordinal: 1,
                        Mode: itemAct.tab.mode
                    };

                    axios.put('api/webtabs/add', newtab).then(() => {
                        this.fetchTabs();
                    });
                }
            }
        }
    }
}
</script>
